// Web styles for preview
const styles = {
  container: {
    width: '100%',
    maxWidth: 1200,
    margin: '0 auto',
    background: '#ffffff',
    borderRadius: 2,
    boxShadow: '0 0px 0px rgba(0,0,0,0.08)',
    border: '1px solid #e5e7eb',
    overflow: 'hidden',
    marginBottom: 24,
    fontFamily: 'Montserrat',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
    color: '#ffffff',
    backgroundSize: 'cover',
    backgroundPosition: 0
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 24,
  },
  logoBox: {
    padding: '8px 16px',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 54,
    height: 54,
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    }
  },
  logoText: {
    fontSize: 14,
    fontWeight: 700,
    color: '#1e40af',
    letterSpacing: 0.5,
    fontFamily: 'Montserrat',
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 8,
  },
  title: {
    fontSize: '32px !important',
    fontWeight: 700,
    lineHeight: 1.2,
    color: '#121f2b',
    marginBottom: 8,
    fontFamily: 'Montserrat',
  },
  subtitle: {
    fontSize: '14px !important',
    color: '#00393d',
    lineHeight: 1.5,
    maxWidth: 600,
    fontFamily: 'Montserrat',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
  },
  dateBadge: {
    background: '#00b3c7',
    padding: '8px 16px',
    borderRadius: 6,
    marginRight: 8,
  },
  dateBadgeText: {
    fontSize: '16px !important',
    fontWeight: 500,
    color: '#ffffff',
    letterSpacing: 0.5,
    fontFamily: 'Montserrat',
  },
  card: {
    border: '1px solid #f3f4f6',
    borderRadius: '16px'
  },
  cardHeader: {
    padding: '12px 16px',
    borderBottom: '1px solid #f3f4f6',
  },
  blueCardHeader: {
    backgroundColor: '#00b3c7',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
  },
  cardHeaderTitle: {
    fontWeight: 600,
    fontSize: '16px !important',
    fontFamily: 'Montserrat',
  },
  colorWhite: {
    color: '#ffffff !important',
  },
  cardBody: {
    padding: '16px',
    flex: 1,
  },
  cardBodyText: {
    fontSize: '12px !important',
    color: '#374151',
    lineHeight: 1.5,
    fontFamily: 'Montserrat',
  },
  mainContent: {
    padding: 24,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 24,
  },
  splitContent: {
    display: 'flex',
    gap: 24,
  },
  leftColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 24,
  },
  rightColumn: {
    width: 380,
    flexShrink: 0,
  },
  chartPlaceholder: {
    width: '100%',
    minHeight: 300,
    border: '2px dashed #cbd5e1',
    borderRadius: 6,
    background: '#f8fafc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
    boxSizing: 'border-box'
  },
  chartContainer: {
    width: '100%',
    height: 300,
  },
  placeholderText: {
    fontSize: 16,
    color: '#64748b',
    textAlign: 'center' as const,
    fontFamily: 'Montserrat',
  },
  noticeBox: {
    width: '100%',
    minHeight: 300,
    borderRadius: 6,
    background: '#f8fafc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    boxSizing: 'border-box'
  },
  noticeText: {
    fontSize: 14,
    lineHeight: 1.4,
    color: '#1f2937',
    textAlign: 'center' as const,
    fontFamily: 'Montserrat',
    maxWidth: 520
  },
  noticeInline: {
    fontSize: 11,
    lineHeight: 1.4,
    color: '#1f2937',
    fontFamily: 'Montserrat',
    marginTop: 8
  },
  fundManagerSection: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 16,
    borderTop: '1px solid #f3f4f6',
    padding: 16,
  },
  fundManagerContent: {
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start',
  },
  fundManagerPhoto: {
    width: 132,
    height: 132,
    borderRadius: '16px',
    objectFit: 'cover' as const,
    border: '2px solid #e5e7eb',
  },
  fundManagerPhotoPlaceholder: {
    width: 132,
    height: 132,
    borderRadius: '16px',
    background: '#e5e7eb',
    border: '2px solid #cbd5e1',
  },
  fundManagerInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
  },
  fundManagerName: {
    fontSize: "16px !important",
    fontWeight: 700,
    color: '#121f2b',
    fontFamily: 'Montserrat',
  },
  fundManagerCompany: {
    fontSize: "14px !important",
    lineHeight: '18px',
    color: '#003C50',
    fontFamily: 'Montserrat',
  },
  fundManagerResearch: {
    fontSize: "14px !important",
    lineHeight: '18px',
    color: '#003C50',
    fontFamily: 'Montserrat',
  },
  fundManagerCompany2: {
    fontSize: "14px !important",
    lineHeight: '18px',
    color: '#003C50',
    fontFamily: 'Montserrat',
  },
  fundManagerPhone: {
    fontSize: "14px !important",
    lineHeight: '18px',
    color: '#003C50',
    fontFamily: 'Montserrat',
  },
  hedgingButton: {
    marginTop: 4,
    background: '#00b3c7',
    padding: '0 8px',
    borderRadius: 6,
    alignSelf: 'flex-start',
  },
  hedgingButtonText: {
    fontSize: '14px !important',
    fontWeight: 600,
    color: '#ffffff',
    fontFamily: 'Montserrat',
  },
  commentarySection: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 12,
  },
  commentaryTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: '#111827',
    fontFamily: 'Montserrat',
  },
  commentaryText: {
    fontSize: '12px',
    color: '#00393d',
    lineHeight: 1.2,
    whiteSpace: 'pre-wrap' as const,
    fontFamily: 'Montserrat',
    span: {
      fontSize: '12px',
      lineHeight: 1.2,
      fontFamily: 'Montserrat',
    }
  },
  sidebar: {
    background: '#002e3d',
    borderRadius: 6,
    padding: '16px 24px',
    color: '#ffffff',
  },
  sidebarSection: {
    marginBottom: 24,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  sidebarSectionTitle: {
    fontSize: '16px !important',
    fontWeight: 700,
    color: '#fff',
    marginBottom: '18px !important',
    letterSpacing: 0.5,
    fontFamily: 'Montserrat',
  },
  kvGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 10,
  },
  kvRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  kvLabel: {
    fontSize: '14px !important',
    color: '#ffffffcc',
    flex: 1,
    lineHeight: 1,
    fontFamily: 'Montserrat',
  },
  kvValue: {
    fontSize: '14px !important',
    color: '#fff',
    fontWeight: 500,
    flex: 1,
    textAlign: 'right' as const,
    lineHeight: 1.2,
    fontFamily: 'Montserrat',
  },
  performanceTable: {
    width: '100%',
    marginTop: 8,
  },
  performanceTableHeader: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #e5e7eb',
    backgroundColor: '#f3f4f6',
  },
  performanceTableHeaderCell: {
    flex: 1,
    padding: '8px 12px',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#111827',
    textAlign: 'center',
    fontFamily: 'Montserrat',
  },
  performanceTableRow: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#ffffff',
  },
  performanceTableCell: {
    flex: 1,
    padding: '8px 12px',
    fontSize: '12px',
    color: '#111827',
    textAlign: 'center',
    fontFamily: 'Montserrat',
  },
  explanatoryText: {
    marginTop: 24,
    paddingTop: 24,
    borderTop: '1px solid #e5e7eb',
  },
  explanatoryTextTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: 12,
    fontFamily: 'Montserrat',
  },
  explanatoryTextContent: {
    fontSize: '12px !important',
    color: '#00393d',
    lineHeight: 1.6,
    marginBottom: 8,
    fontFamily: 'Montserrat',
    '& strong': {
      fontWeight: 'bold',
      color: '#111827',
      fontFamily: 'Montserrat',
    },
  },
  twoColumn: {
    display: 'flex',
    flexDirection: 'row' as const,
    gap: '16px',
  },
  bulletItem: {
    display: 'flex',
    flexDirection: 'row' as const,
    marginBottom: '8px',
    gap: '8px',
  },
  bulletPoint: {
    fontSize: '14px !important',
    color: '#6b7280',
    fontWeight: 600,
    minWidth: '16px',
    fontFamily: 'Montserrat',
  },
  bulletText: {
    fontSize: '12px !important',
    color: '#6b7280',
    lineHeight: 1.5,
    flex: 1,
    fontFamily: 'Montserrat',
  },
  legalKvRow: {
    display: 'flex',
    flexDirection: 'row' as const,
    marginBottom: '8px',
    gap: '8px',
  },
  legalKvLabel: {
    fontSize: '12px !important',
    color: '#111827',
    fontWeight: 600,
    fontFamily: 'Montserrat',
  },
  legalKvValue: {
    fontSize: '12px !important',
    color: '#374151',
    flex: 1,
    fontFamily: 'Montserrat',
  },
  legalText: {
    fontSize: '12px !important',
    color: '#374151',
    lineHeight: 1.5,
    marginTop: '12px',
    fontFamily: 'Montserrat',
    '&:first-of-type': {
      marginTop: 0,
    },
  },
  legalSeparator: {
    width: '100%',
    height: '1px',
    backgroundColor: '#000000',
    marginTop: '12px !important',
    marginBottom: '12px !important',
  },
  twoColumnCards: {
    display: 'flex',
    gap: 16,
    width: '100%',
  },
  strategyCard: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 0,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  awardsCard: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 0,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
  },
  strategyText: {
    fontSize: '12px !important',
    color: '#00393d',
    lineHeight: 1.6,
    fontFamily: 'Montserrat',
  },
  awardPlaceholderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  awardPlaceholder: {
    backgroundColor: '#f3f4f6',
    borderRadius: 6,
    marginBottom: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 80,
    height: 80,
  },
  awardPlaceholderText: {
    fontSize: '16px',
    color: '#9ca3af',
    fontWeight: 500,
    fontFamily: 'Montserrat',
  },
  awardPlaceholderLabel: {
    fontSize: '12px !important',
    color: '#00393d',
    textAlign: 'center',
    fontFamily: 'Montserrat',
  },
  fourCardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,
    width: '100%',
  },
  allocationCard: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 0,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  stockList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  stockListItem: {
    fontSize: '14px !important',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  stockListNumber: {
    fontSize: '14px !important',
    color: '#111827',
    fontWeight: 500,
    minWidth: 24,
    fontFamily: 'Montserrat',
  },
  stockListName: {
    fontSize: '14px !important',
    color: '#111827',
    flex: 1,
    fontFamily: 'Montserrat',
  },
  stockListPercentage: {
    fontSize: '14px !important',
    color: '#111827',
    fontWeight: 500,
    minWidth: 50,
    textAlign: 'right',
    fontFamily: 'Montserrat',
  },
  threePanelGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 16,
    width: '100%',
    marginTop: 16,
  },
  infoPanel: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 0,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
  },
  infoPanelHeader: {
    backgroundColor: '#00b3c7',
    borderRadius: '8px 8px 0 0',
    padding: '12px 16px',
  },
  infoPanelTitle: {
    fontSize: '14px !important',
    fontWeight: 'bold',
    color: '#ffffff',
    fontFamily: 'Montserrat',
  },
  infoPanelBody: {
    padding: '16px',
    flex: 1,
  },
  infoPanelText: {
    fontSize: '12px !important',
    color: '#111827',
    lineHeight: 1.6,
    fontFamily: 'Montserrat',
  },
  riskScaleLabels: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  riskScaleLabel: {
    fontSize: '11px !important',
    color: '#111827',
    fontWeight: 500,
    fontFamily: 'Montserrat',
  },
  riskScaleBoxes: {
    display: 'flex',
    gap: 4,
    marginBottom: 8,
    justifyContent: 'center',
  },
  riskScaleBox: {
    width: 32,
    height: 32,
    borderRadius: 1,
    backgroundColor: '#e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #d1d5db',
  },
  riskScaleBoxActive: {
    backgroundColor: '#00b3c7',
    border: '1px solid #00b3c7',
  },
  riskScaleBoxNumber: {
    fontSize: '14px !important',
    fontWeight: 'bold',
    color: '#374151',
    fontFamily: 'Montserrat',
  },
  riskScaleBoxNumberActive: {
    color: '#ffffff',
    fontFamily: 'Montserrat',
  },
  riskGradientBar: {
    height: 8,
    borderRadius: 4,
    background: 'linear-gradient(to right, #00393d, #00b3c7)',
    marginBottom: 8,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  riskGradientBarInner: {
    flex: 1,
    height: '100%',
  },
  riskGradientArrow: {
    position: 'absolute',
    right: -8,
    fontSize: '12px !important',
    color: '#00b3c7',
    fontFamily: 'Montserrat',
  },
  riskDisclaimerText: {
    fontSize: '10px !important',
    color: '#6b7280',
    lineHeight: 1.5,
    marginTop: 12,
    fontStyle: 'italic',
    fontFamily: 'Montserrat',
  },
};

export default styles;
